import tokenService from "./tokenService";
import io from "socket.io-client";

export default {
    tcpService: function (that) {
        if (window["WebSocket"]) {
            // 1握手（包含会话 ID — 此处zBjrh...AAAK— 用于后续请求）
            // 2发送数据（HTTP 长轮询）
            // 3接收数据（HTTP 长轮询）
            // 4升级（WebSocket）
            // 5 接收数据（当WebSocket连接建立成功后关闭HTTP长轮询）
            //let socket = io("ws://localhost:8081")
            // let socket = io("http://localhost:8081", {
            //     withCredentials: true //跨域设置
            // })

            let token = tokenService.getToken();
            let socket = io(process.env.VUE_APP_SOCKET, {
                //path:'/api/socket.io',
                reconnection: true, //重新连接
                transports: ['polling', 'websocket'],
                transportOptions: {
                    polling: {
                        extraHeaders: {
                            "Authorization": 'Bearer ' + token,//验证码
                        }
                    }
                }
            })
            //var s2 = io("/chat");

            // client-side
            socket.on("connect", () => {
                //console.log("connect-socket.id", socket.id);

                // const engine = socket.io.engine;
                //
                // engine.once("upgrade", () => {
                //     // called when the transport is upgraded (i.e. from HTTP long-polling to WebSocket)
                // });

                //加入房间
                this.joinroom(that)
            });

            socket.on("disconnect", (reason) => {
                if (reason === "io server disconnect") {
                    // 服务器主动断开 需要手动连接
                    socket.connect();
                }
                // else the socket will automatically try to reconnect
            });
            socket.on("disconnected", () => {
            });
            socket.on("close", () => {
            });


            // socket.on("connect_error", (error) => {
            //     // setTimeout(() => {
            //     //     let res = socket.connect();
            //     // }, 1000);
            // });

            //服务器推送新增节点
            socket.on('addNode', (data) => {
                let node = JSON.parse(data)
                if (that.nowAddNodeId !== node.id) {
                    that.graph.addNode(node);
                }
            });
            //服务器推送更新节点
            socket.on('updateNode', (data) => {
                let node = JSON.parse(data)
                const cell = that.graph.getCellById(node.id);
                cell.label = node.label
                cell.setPosition(node.x, node.y)
                cell.setZIndex(node.zIndex)

                //console.log("!!!!!!!!!###", socket.id, node)
            });
            socket.on('deleteNode', (data) => {
                let node = JSON.parse(data)
                const cell = that.graph.getCellById(node.id);
                that.graph.removeCell(cell)
            });
            socket.on('noAuth', (data) => {
                //跳转登录
                that.$message.error(data)
                // request.redirectToLogin();
            });
            socket.on('errorInfo', (data) => {
                that.$message.error(data)
            });

            socket.on("reconnect_attempt", () => {
                //尝试重新连接
                console.log('尝试重新连接')
            });

            socket.on("reconnect", () => {
                //重新连接
                console.log('重新连接')
            });

            return socket
        } else {
            that.$message.error("浏览器不支持socket")
            return null
        }
    },

    joinroom: function (that) {
        let node = {
            dataListId: that.dataListId,
            userId: that.userId,
        }
        //加入房间
        that.socket.emit('joinRoom', JSON.stringify(node));
    },
    nodes: function () {
        const widthDefalut = 76
        const heightDefault = 76
        const widthDefalut2 = 140
        return [
            {
                color: '#9ac12a',
                stroke: '#151514',
                name: 'model',
                text: 'Read Model',
                width: widthDefalut,
                height: heightDefault
            },
            {
                color: '#26aaff',
                stroke: '#151514',
                name: 'commamd',
                text: 'Commamd',
                width: widthDefalut,
                height: heightDefault
            },
            {
                color: '#fe8a01',
                stroke: '#151514',
                name: 'event',
                text: 'Event',
                width: widthDefalut,
                height: heightDefault
            },
            {
                color: '#e400b6',
                stroke: '#151514',
                name: 'waring',
                text: 'Waring',
                width: widthDefalut,
                height: heightDefault
            },

            {
                color: '#e1a1bf',
                stroke: '#151514',
                name: 'system',
                text: 'System',
                width: widthDefalut2,
                height: heightDefault
            },
            {
                color: '#efe0ff',
                stroke: '#151514',
                name: 'policy',
                text: 'Policy',
                width: widthDefalut2,
                height: heightDefault
            },
            {
                color: '#ffef87',
                stroke: '#151514',
                name: 'aggregate',
                text: 'Aggregate',
                width: widthDefalut2,
                height: heightDefault
            },

            {
                color: '#fef72d',
                stroke: '#151514',
                name: 'role',
                text: 'User',
                width: widthDefalut * 2 / 3,
                height: heightDefault * 2 / 3
            },
            {
                color: '#ffffff',
                stroke: '#151514',
                name: 'textNode',
                text: 'text',
                width: widthDefalut,
                height: heightDefault / 2
            }
        ]
    },
    exampleNodes: function () {
        return [
            {
                "id": "031d5b45-9056-4812-b776-14671269e6c5",
                "shape": "event",
                "label": "拖拽\n新增节点",
                "x": -413,
                "y": -358,
                "zIndex": 7
            },
            {
                "id": "0939290f-444a-404c-97a7-78f0a0c61cd5",
                "shape": "role",
                "label": "User\n用户",
                "x": -602,
                "y": 76,
                "zIndex": 36
            },
            {
                "id": "0df9c42c-1760-4c85-be5d-c1be9bad0705",
                "shape": "commamd",
                "label": "授权完成",
                "x": -602,
                "y": -430,
                "zIndex": 6
            },
            {
                "id": "17b70ad0-6001-4971-aba0-d585eb59a194",
                "shape": "model",
                "label": "Read Model\n读取模型",
                "x": -706,
                "y": 107,
                "zIndex": 28
            },
            {
                "id": "196b9b31-f3da-4879-9b6d-eaa7e006b59e",
                "shape": "textNode",
                "label": "页面",
                "x": 17,
                "y": -430,
                "zIndex": 21
            },
            {
                "id": "1b839dbb-090b-454c-baab-9f5e3e61ee63",
                "shape": "commamd",
                "label": "授权",
                "x": -754,
                "y": -430,
                "zIndex": 0
            },
            {
                "id": "22e4b802-ecaf-4a7d-bb17-c9370ee0f649",
                "shape": "model",
                "label": "节点",
                "x": -165,
                "y": -308,
                "zIndex": 26
            },
            {
                "id": "261d81be-bfa3-451a-985d-a96e4c5317a5",
                "shape": "commamd",
                "label": "开启风暴",
                "x": -526,
                "y": -354,
                "zIndex": 11
            },
            {
                "id": "2e8225e8-7929-4c6c-8c3d-972a70a4a0e6",
                "shape": "commamd",
                "label": "写入数据\n库",
                "x": -89,
                "y": -308,
                "zIndex": 23
            },
            {
                "id": "306ae1aa-d552-40ab-acf4-f28e70433189",
                "shape": "model",
                "label": "在线授权\n用户",
                "x": -165,
                "y": -222,
                "zIndex": 25
            },
            {
                "id": "34b2ffdb-2ab8-46a6-8ec7-16f56faff813",
                "shape": "model",
                "label": "UI显示",
                "x": 27,
                "y": -270,
                "zIndex": 20
            },
            {
                "id": "39aaf4dd-0612-447e-9b6f-80484be1864c",
                "shape": "event",
                "label": "编辑节点",
                "x": -337,
                "y": -358,
                "zIndex": 9
            },
            {
                "id": "45afcd2b-5606-4078-b083-54f4b43bc735",
                "shape": "model",
                "label": "授权\n用户\n列表",
                "x": -526,
                "y": -430,
                "zIndex": 5
            },
            {
                "id": "45ed0daf-1775-45fd-b335-c5af7a30e89b",
                "shape": "textNode",
                "label": "事件风暴",
                "x": -377,
                "y": -70,
                "zIndex": 27
            },
            {
                "id": "4f783710-8e8b-416d-900e-f90d4db7a507",
                "shape": "textNode",
                "label": "事件风暴\n在线工具设计",
                "x": -377,
                "y": -520,
                "zIndex": 22
            },
            {
                "id": "5d69192d-e042-47d5-bdc5-1bc388134386",
                "shape": "commamd",
                "label": "获取最新\n节点",
                "x": -565,
                "y": -270,
                "zIndex": 24
            },
            {
                "id": "6115f528-ae40-4e32-a40f-d1f5cb33f0d4",
                "shape": "model",
                "label": "风暴\n列表",
                "x": -678,
                "y": -430,
                "zIndex": 4
            },
            {
                "id": "62655824-aa40-4bc0-aed8-c23b3c6d95ad",
                "shape": "commamd",
                "label": "Commamd\n命令",
                "x": -33,
                "y": 0,
                "zIndex": 35
            },
            {
                "id": "63788a3b-bbab-4cfc-89ff-79d4ca0adc46",
                "shape": "system",
                "label": "System\n外部系统",
                "x": -467,
                "y": 0,
                "zIndex": 31
            },
            {
                "id": "6d8bed82-c51a-4d8b-b7aa-df7c3f41fe23",
                "shape": "event",
                "label": "置于顶层",
                "x": -413,
                "y": -210,
                "zIndex": 15
            },
            {
                "id": "6da02f2f-6679-46a8-a13d-bb6e927ddbf8",
                "shape": "textNode",
                "label": "socket.io",
                "x": -377,
                "y": -430,
                "zIndex": 8
            },
            {
                "id": "705613fc-7f97-4095-bbb3-c0dc943c947a",
                "shape": "event",
                "label": "删除",
                "x": -413,
                "y": -286,
                "zIndex": 14
            },
            {
                "id": "891bf4ff-5f72-444e-8481-09eb85366e69",
                "shape": "event",
                "label": "Event\n领域事件",
                "x": -311,
                "y": 0,
                "zIndex": 32
            },
            {
                "id": "9bee2671-5e6a-4042-a34f-5085a307b624",
                "shape": "role",
                "label": "User\n用户",
                "x": -780,
                "y": -380,
                "zIndex": 1
            },
            {
                "id": "a069c8de-13bb-4088-9e2e-278ff4675804",
                "shape": "event",
                "label": "移动",
                "x": -337,
                "y": -286,
                "zIndex": 16
            },
            {
                "id": "a934d77b-a500-41e5-a017-c91857509253",
                "shape": "event",
                "label": "加入房间",
                "x": -489,
                "y": -270,
                "zIndex": 13
            },
            {
                "id": "b1d80c22-0d51-481f-b48e-8557d18e130c",
                "shape": "event",
                "label": "置于底层",
                "x": -337,
                "y": -210,
                "zIndex": 17
            },
            {
                "id": "bb422df0-d18f-4149-a5b6-464422e0b856",
                "shape": "commamd",
                "label": "Commamd\n命令",
                "x": -565,
                "y": 17,
                "zIndex": 30
            },
            {
                "id": "c1ce3b77-cb06-4d6a-8b3d-97c119cbdfd7",
                "shape": "commamd",
                "label": "请求后端",
                "x": -261,
                "y": -286,
                "zIndex": 18
            },
            {
                "id": "c8737890-e509-44d4-8bd4-d09779dc960b",
                "shape": "textNode",
                "label": "房间",
                "x": -146,
                "y": -430,
                "zIndex": 10
            },
            {
                "id": "cf4cd667-0a5d-4389-942d-cd4e4ef45840",
                "shape": "commamd",
                "label": "根据房间\n人员推送",
                "x": -89,
                "y": -222,
                "zIndex": 19
            },
            {
                "id": "ef9dd9b9-4e5d-46f1-9fe0-8ed8d313f4fc",
                "shape": "policy",
                "label": "Policy\n规则",
                "x": -197,
                "y": 0,
                "zIndex": 33
            },
            {
                "id": "ff563f80-bc52-4509-9b08-929d5d01ea74",
                "shape": "role",
                "label": "User\n用户",
                "x": -57,
                "y": 57,
                "zIndex": 37
            }
        ];
    }
}
